/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { TokenStorageService } from './app/service/token-storage.service';

// 外部跳轉登入（如 LINE 帶 ?token= 的深連結）：在啟動前先把 token 存入，
// 讓後續 APP_INITIALIZER 的身份驗證能直接通過，並將 token 從網址移除避免外洩/重複處理。
(() => {
  try {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      TokenStorageService.setTokenFromAuthResponse(token);
      params.delete('token');
      const qs = params.toString();
      const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
    }
  } catch (e) {
    console.error('token bootstrap from URL failed', e);
  }
})();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
